<template>
    <!-- <div class="siteicon" :class="{['style'+iconStyle]:true, 'compact':compact}"> -->
        <md-avatar class="siteicon" :class="{['style'+iconStyle]:true, 'compact':compact, 'pulse': (link.pulse && (account == 7 || enableUpgrades)), 'md-large': !compact , 'quickLinkMargin': isQuicklink}" v-bind:style="{ color: link.color, background: link.background }" style="display:flex">
            <i v-if="!link.favicon && link.site != 'Image'" class="fa fa-fw" v-bind:class="['fa-'+ link.fa, {'fa-lg': compact,'fa-2x': !compact, 'fa-3x': (iconStyle == 2 && !compact)}]" v-bind:style="{ color: link.color,  }" aria-hidden="true" ></i>
            <img v-else-if="link.favicon && link.site != 'Image' && (link.faviconFull == true || link.faviconFull == 1)" v-bind:src="link.favicon" style="object-fit:cover; " @error="errorImage(link.site)" v-bind:style="link.iconStyling"/>
            <img v-else-if="link.favicon && link.site != 'Image' && (link.faviconFull == false || link.faviconFull == 0)" v-bind:src="link.favicon" v-bind:class="{'compactIcon': compact, 'largeIcon': !compact}" @error="errorImage(link)" />
            <img v-else-if="link.site == 'Image'" :src="link.user.replace('https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o','https://ik.imagekit.io/slink/tr:n-favicon')" style="object-fit:cover"/>
        </md-avatar>
    <!-- </div> -->
</template>

<script>
    export default {
        props:{
            link: Object,
            account: Number,
            enableUpgrades: Boolean,
            isQuicklink: Boolean,
            compact: Boolean,
            iconStyle: Number,
        },
        data() {
            return {
            };
        },
        methods:{
            errorImage: function(site){
                this.link.favicon = 'https://www.google.com/s2/favicons?domain='+site.base + site.user.trim() + site.suffix
                this.link.faviconFull = false
            }
        },
        created () {
  	        // console.log(`PROPS ${this.link.site} ${this.iconStyle}`)
        }
    }
</script>

<style scoped>

.siteicon{
    box-shadow: 0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);
}

.siteicon{
    justify-content: center;
    align-items: center;
    display: flex;
}

.siteicon .largeIcon{
    height:32px;
    width:32px;
    object-fit: cover;
}

.siteicon.style1{
    border-radius:7px;
}

.siteicon.style2{
    border-radius:unset;
    width:80px;
    height:80px;
    padding:8px;
}

.siteicon.style2.compact{
    border-radius:unset;
    width:56px;
    height:56px;
    padding:0px;
}

.compact .md-avatar .compactIcon{
    width:24px;
    height:24px;
    padding:0px;
}

.md-avatar.compact .compactIcon{
    width:24px;
    height:24px;
    padding:0px;
}

.siteicon.style2.compact .compactIcon{
    border-radius:unset;
}

.md-avatar img{
    aspect-ratio:1/1;
}















.siteicon {
    align-self: baseline;
}

.siteicon .md-avatar.quicklink{
  border-width: 1px; border-color: silver; border-style: solid;text-align: center; margin:8px 4px
}

/* .quickLinkMargin{
    margin-right:unset !important
} */

.quickLinksIconStyle2 .md-avatar{
    border-radius:unset;
    /* min-width:56px;
    min-height:56px;
    padding:8px;
    width:100%;
    border-width:0px 1px 0px 0px; 
    border-style: solid;
    border-color: #f5f5f577 */
    border-style:none;
    width:100%;
    height:100%;
    min-height:56px;
    padding-top:8px
    /* display: flex; */
  /* justify-content: center; */
  /* align-items: center; */
}

.quickLinksIconStyle2 .compactIcon{
  width:24px !important;
  height:24px !important;
}

.link.style2 .link .icon .siteicon{
    box-shadow:unset;
    /* position:absolute; */
  top:0px;
  margin-top:unset;
  /* display:flex; */
  
}

.siteicon.style2{
    padding:unset;
    display:flex;
}
</style>


// WEBPACK FOOTER //
// src/components/siteicon_component.vue